/**
 * @description Class to check if the browser allows popups
 */
export default class BrowserSettings {
    /**
     * @description Check if the browser alow popups
     * @returns {boolean}
     */
    checkPopUpBlocker() {
        const newWindow = window.open('about:blank', '', 'width=1,height=1');
        if (
            !newWindow ||
            newWindow.closed ||
            typeof newWindow.closed === 'undefined' ||
            this.isPopupBlocked(newWindow)
        ) {
            return true;
        }
        newWindow.close();
        return false;
    }

    /**
     * @description Check if the popup is blocked
     * @param {*} newWindow
     * @returns {boolean}
     */
    isPopupBlocked(newWindow) {
        try {
            newWindow.focus();
            return false;
        } catch {
            return true;
        }
    }
}
